import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';
import { useRouter } from 'react-resource-router';

import { useTenantData } from '../../../utils/tenant-context';
import { LayoutBoysenberry } from '../layout-boysenberry';

import type { codeFrame_loadFlowQuery } from './components/__generated__/codeFrame_loadFlowQuery.graphql';
import query from './components/__generated__/codeFrame_loadFlowQuery.graphql';
import { CodeFrame } from './components/code-frame';

export const path = '/boysenberry/flow/:flowId';

export const BoysenberryCodePage = () => {
	const [queryRef, loadQuery] = useQueryLoader<codeFrame_loadFlowQuery>(query);
	const [routeState] = useRouter();

	const { tenantContexts } = useTenantData();
	const { cloudId } = tenantContexts[0];

	const { flowId } = routeState.match.params;

	useEffect(() => {
		if (flowId) {
			loadQuery({ sessionId: flowId, cloudId });
		}
	}, [loadQuery, flowId, cloudId]);

	return (
		<LayoutBoysenberry isFullscreen>
			{queryRef && <CodeFrame queryRef={queryRef} />}
		</LayoutBoysenberry>
	);
};
